import { useDispatch, useSelector } from 'react-redux';
import DateSelector from '../../../shared/components/DateSelector';
import EnviosMetrics from '../EnviosMetrics';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { CustomTooltip } from '../../../shared/helpers/functionalities';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import {
    fetchEnviosByState,
    fetchEnviosMetrics,
    resetShippingResults,
    updateEnviosMetrics,
} from '../../../../../../redux/envios';
import InfoModal from '../../../shared/components/InfoModal';
import EnvioSearchModal from '../EnvioSearchModal';
import EnvioForm from '../EnvioForm';
import { ENVIOS_API  } from '../../../shared/services/envios';
import { toast } from 'react-toastify';
import ExportForm from '../../../shared/components/ExportForm';
import UpdateCfClearenceRF from '../UpdateCfClearenceRF';

export const TabDashboardEnvios = ({ updateNoGeneratedTotal }) => {
    const dispatch = useDispatch();
    const { dashboardTab } = useSelector((state) => state.envios);
    const search = useSelector((state) => {
        return state.search;
    });
    const [startDate, setStartDate] = useState(
        moment().startOf('isoWeek').format('YYYY-MM-DD')
    );
    const [endDate, setEndDate] = useState(
        moment().endOf('isoWeek').format('YYYY-MM-DD')
    );
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [isExportOpen, setIsExportOpen] = useState(false);
    const [isUpdateCfClearenceOpen, setIsUpdateCfClearenceOpen] = useState(false);
    const handleDateInterval = (startDate, endDate, view) => {
        setStartDate(startDate);
        setEndDate(endDate);
        dispatch(fetchEnviosMetrics(startDate, endDate, view));
    };

    const getShippingByState = (estadoId, isNacional, page) => {
        dispatch(
            fetchEnviosByState(
                estadoId,
                isNacional,
                page,
                `&startDate=${startDate}&endDate=${endDate}`
            )
        );
    };

    const refreshDashboardEnvios = () => {
        updateNoGeneratedTotal();
        dispatch(fetchEnviosMetrics(startDate, endDate, true));
    };

    const closeSearchModal = () => {
        setIsSearchOpen(false);
        dispatch(resetShippingResults());
    };

    const handleExportConsumo = async (data) => {
        dispatch({ type: 'loading/set', payload: true });
        try {
            const exportResult = await ENVIOS_API.exportConsumption(data);
            if (exportResult) {
                toast.success(
                    'Listado de consumo de envíos descargado correctamente!'
                );
                const url = window.URL.createObjectURL(new Blob([exportResult]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'envios_consumo.xlsx');
                document.body.appendChild(link);
                return link.click();
            }   
            toast.error('Ups! Algo ha ido mal...');
        } catch (error) {
            toast.error('Ups! Algo ha ido mal...');
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
        setIsExportOpen(false);
    };

    const handleNewEnvio = async (data) => {
        try {
            dispatch({ type: 'loading/set', payload: true });
            const response = await ENVIOS_API.new(data);
            if (response.success) {
                setIsCreateOpen(false);
                const isTodayInRange = moment().isBetween(
                    startDate,
                    endDate,
                    'day',
                    '[]'
                );
                if (isTodayInRange) {
                    dispatch(
                        updateEnviosMetrics(
                            data.destinatario.pais_id === 1,
                            'Desconocido'
                        )
                    );
                }
                return toast.success(response.message);
            }
            toast.error('No se ha podido crear el envío!');
        } catch (error) {
            toast.error(error.message);
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    };

    useEffect(() => {
        dispatch(fetchEnviosMetrics(startDate, endDate));
    }, []);

    useEffect(() => {
        if (search?.key === 'envio') {
            setIsSearchOpen(true);
        }
    }, [search]);

    return (
        <div className="w-100 d-flex flex-column align-items-center dashboard">
            <div className="w-100 summary">
                <div className="w-100 d-flex align-items-center mb-2">
                    <CustomTooltip
                        title={
                            'Última actualización: ' +
                            dashboardTab?.saved_cache_at
                        }
                        onClick={refreshDashboardEnvios}
                    >
                        <IconButton sx={{ color: '#215732' }}>
                            <RefreshIcon />
                        </IconButton>
                    </CustomTooltip>
                    <CustomTooltip
                        title={'Buscar envío'}
                        onClick={() => setIsSearchOpen(true)}
                    >
                        <IconButton sx={{ color: '#215732' }}>
                            <SearchIcon />
                        </IconButton>
                    </CustomTooltip>
                    <CustomTooltip
                        title={'Descargar consumo'}
                        onClick={() => setIsExportOpen(true)}
                    >
                        <IconButton sx={{ color: '#215732' }}>
                            <FileDownloadOutlinedIcon />
                        </IconButton>
                    </CustomTooltip>
                    <CustomTooltip
                        title={'Crear nuevo envío'}
                        onClick={() => setIsCreateOpen(true)}
                    >
                        <IconButton sx={{ color: '#215732' }}>
                            <AddIcon />
                        </IconButton>
                    </CustomTooltip>
                    <CustomTooltip
                        title={'Actualizar cf_clearence seguimiento RF'}
                        onClick={() => setIsUpdateCfClearenceOpen(true)}
                    >
                        <IconButton sx={{ color: '#215732' }}>
                            <DriveFolderUploadIcon />
                        </IconButton>
                    </CustomTooltip>
                    <DateSelector
                        onSelectedDate={handleDateInterval}
                        viewByDefault="ultimos-7dias"
                    />
                </div>
                <EnviosMetrics
                    data={dashboardTab?.shipping_states}
                    getShippingByState={getShippingByState}
                />
            </div>
            {isSearchOpen && (
                <InfoModal
                    state={isSearchOpen}
                    title={`Buscar Envío`}
                    width={'lg'}
                    content={
                        <EnvioSearchModal
                            search={search?.key === 'envio' ? search : null}
                        />
                    }
                    onClose={closeSearchModal}
                />
            )}
            {isCreateOpen && (
                <InfoModal
                    state={isCreateOpen}
                    title={`Nuevo envío`}
                    width={'lg'}
                    content={<EnvioForm onSubmitEnvio={handleNewEnvio} />}
                    onClose={() => setIsCreateOpen(false)}
                />
            )}
            {isExportOpen && (
                <InfoModal
                    state={isExportOpen}
                    title="Exportar consumo de envíos"
                    content={
                        <ExportForm
                            dateFilter={true}
                            transportistasFilter={true}
                            tipoClienteFilter={false}
                            tipoFacturasFilter={false}
                            responsableFilter={false}
                            onSubmitExport={handleExportConsumo}
                        />
                    }
                    onClose={() => setIsExportOpen(false)}
                ></InfoModal>
            )}
            {isUpdateCfClearenceOpen && (
                <InfoModal
                    state={isUpdateCfClearenceOpen}
                    title={'Actualizar cf_clearence seguimiento RF'}
                    width={'sm'}
                    content={<UpdateCfClearenceRF />}
                    onClose={() => setIsUpdateCfClearenceOpen(false)}
                />
            )}
        </div>
    );
};
